export default __webpack_public_path__ + "static/not-found-8180af9e2f6386ba9e33fc5203a5b437.svg";